import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Profile {
    id: string;
    email: string;
    name: string;
    roles: string[];
}
@Injectable({providedIn: 'root'})
export class ProfileService {
    private _profile: Profile;

    public get profile(): Profile {
        return this._profile;
    }


    constructor(private http: HttpClient) {
    }

    load(force = false): Observable<Profile> {
        if (force || !this._profile) {
            return this.http.get<Profile>('/users/me').pipe(map(res => this._profile = res));
        }
        return new Observable(obs => {
            obs.next(this._profile);
            obs.complete();
        });
    }

    clear() {
        this._profile = null;
    }
}
